module.exports = __webpack_public_path__ + "img/lasource-2.1f59b7d9.jpg";